import React from 'react';
import AuthorsList from './AuthorsList';

var ContentHtml = function ContentHtml(_ref) {
  var content = _ref.content,
      _ref$contentPreview = _ref.contentPreview,
      contentPreview = _ref$contentPreview === undefined ? '' : _ref$contentPreview,
      handleAuthorClick = _ref.handleAuthorClick,
      _ref$ReadingTimeIconC = _ref.ReadingTimeIconComponent,
      ReadingTimeIconComponent = _ref$ReadingTimeIconC === undefined ? null : _ref$ReadingTimeIconC;
  var titulo = content.titulo,
      principioAtivo = content.principioAtivo,
      _content$autores = content.autores,
      autores = _content$autores === undefined ? [] : _content$autores,
      _content$conteudoHtml = content.conteudoHtml,
      conteudoHtml = _content$conteudoHtml === undefined ? '' : _content$conteudoHtml,
      _content$minutosLeitu = content.minutosLeitura,
      minutosLeitura = _content$minutosLeitu === undefined ? '' : _content$minutosLeitu;
  return React.createElement('div', {
    className: 'container'
  }, React.createElement('h1', null, titulo || principioAtivo), React.createElement(AuthorsList, {
    values: autores,
    handleClick: handleAuthorClick
  }), minutosLeitura && React.createElement('p', {
    style: {
      marginTop: '-40px',
      marginBottom: '30px'
    }
  }, ReadingTimeIconComponent && React.createElement(ReadingTimeIconComponent, {
    style: {
      width: '1rem',
      verticalAlign: 'middle',
      marginLeft: 5,
      marginRight: 3
    }
  }), ' ', minutosLeitura, ' min de leitura'), React.createElement('div', {
    dangerouslySetInnerHTML: {
      __html: contentPreview || conteudoHtml
    }
  }));
};

export default ContentHtml;